import { Grid, Card, Button, Typography } from '@mui/material'
import { ReactComponent as User} from '../../../icons/user.svg';
import { ReactComponent as ExpressIcon} from '../../../icons/express.svg';
import colors from '../../colors';
import React from 'react'
import { makeStyles } from '@mui/styles';
import { useDispatch, useSelector } from 'react-redux';
import {incrementCurrentRegistrationStep, setShouldFourthStepBeSkipped, setAccountType} from '../../../features/registration/registrationSlice'
import { texts } from '../../general/texts';
import FacephiFlow from '../facephi/FacephiFlow';
import { selectLoginState } from '../../../features/login/loginSlice';


export const IndividualOrExpressAccountTypes = () => {

    const loginSlice = useSelector(selectLoginState)

    const useStyles = makeStyles({
        card:{
            background:colors.cyan,
            width:'50%',
            borderRadius:'20px',
            '@media (max-width: 899px)' : {width:'90%'}
        },
        cardButton:{
            "&:hover":{backgroundColor:colors.lightGray},
            width:'100%',
            height:"100%",
            paddingBottom:'7.2%'
        },
        cardText:{
            color:colors.darkBlue,
            fontFamily:'GerberaLight',
            textTransform:'none',
            fontSize:'1rem'
        },
        cardTextGrid:{
            paddingTop:'10%',
            paddingLeft:'5%'
        }
    })

    const classes = useStyles()
    const [showFacePhi, setShowFacePhi] = React.useState(false);

    const dispatch = useDispatch()

    const handleButtonClick = (value) => 
    {
        dispatch(setAccountType(value))
        if(loginSlice.isManualRegistration) { 
            value === 1 ? dispatch(setShouldFourthStepBeSkipped(true)) : dispatch(incrementCurrentRegistrationStep())
        } else { 
            value === 1 ? dispatch(setShowFacePhi(true)) : dispatch(incrementCurrentRegistrationStep())
        }
    }

  return (
    <Grid container>
       {showFacePhi ? (
        <Grid container pt={'5%'}>
             <FacephiFlow  />
        </Grid>
        ) : (
            <Grid container pt={'5%'} rowSpacing={15} columnSpacing={5} justifyContent={'center'}>
            <Grid container item md={6} xs={12} justifyContent={'right'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}}  >
                <Card elevation={0} className={classes.card} >
                    <Button onClick={()=> {handleButtonClick(1)}} disableRipple={true} className={classes.cardButton}>
                        <Grid item container md={12} >
                            <Grid item md={3} xs={3} pt={'6%'} >
                                <User />
                            </Grid>
                            <Grid item md={9} xs={9} className={classes.cardTextGrid}>
                                <Typography className={classes.cardText} textAlign='left'>{texts["account-type-eWallet"]}</Typography>
                            </Grid>
                        </Grid>
                    </Button>
                </Card>
            </Grid>
            <Grid container item md={6} xs={12} justifyContent={'left'} sx={{'@media (max-width: 899px)' : {justifyContent:'center'}}}  >
                <Card elevation={0} className={classes.card} >
                    <Button onClick={()=> {handleButtonClick(3)}} disableRipple={true} className={classes.cardButton}>
                        <Grid item container md={12} xs={12} >
                            <Grid item md={3} xs={3} sx={{pt:'6%'}} >
                                <ExpressIcon />
                            </Grid>
                            <Grid item md={9} xs={9} className={classes.cardTextGrid}>
                                <Typography className={classes.cardText}  textAlign='left'>{texts["account-type-basic"]}</Typography>
                            </Grid>
                        </Grid>
                    </Button>
                </Card>
            </Grid>
        </Grid>
        )}
    
    </Grid>
  )
}
export default IndividualOrExpressAccountTypes